import React from 'react'
import {Link} from 'react-router-dom'
import {SocialComponent} from '../utils/links'
import logo from '../assets/logo.webp'
 
function Footer() {
    return (
        <footer className="footer">
            <section className="footer-section">
                <div className="footer-grid">
                    <div className="spacing">
                        <h5 className="title footer-title">logo</h5>
                        <img src={logo} alt="logo flauto magico" className="logo" draggable={false}/>
                    </div>
                    <div className="spacing">
                        <h5 className="title footer-title"><Link to="/menu">menù</Link></h5>
                        <ul className="footer-list">
                            <li>Caffé</li>
                            <li>The</li>
                            <li>Spremute</li>
                            <li>Vini</li>
                            <li>Birre</li>
                        </ul>
                    </div>
                    <div className="spacing">
                        <h5 className="title footer-title">indirizzo</h5>
                        <ul className="footer-list">
                            <li>Via Custoza 31</li>
                            <li>San Benedetto del Tronto - 63074</li>
                            <li>Ascoli Piceno - Marche</li>
                        </ul>
                    </div>
                    <div className="spacing">
                        <h5 className="title footer-title"><Link to="/contattaci">contatti</Link></h5>
                        <ul className="footer-list">
                            <li>0735 592451</li>
                            <li><SocialComponent/></li>

                        </ul>
                    </div>
                </div>
            </section>
            <hr/>
            <section className="footer-section">
                <div className="title spacing footer-title">
                    &copy; 2021 <span style={{fontSize:"larger"}}>Flauto Magico</span>
                </div>
                <div className="title inline-section">
                    <Link to="/termsandconditions"><h5 className="spacing">Termini e Condizioni</h5></Link>
                    <Link to="/privacy"><h5 className="spacing">Privacy Policy</h5></Link>
                </div>
            </section>
            
        </footer>
    )
}

export default Footer
